import axios from "axios";

const SERVICES_URL = process.env.UMPIRE_REST_URI;
const API_URL = `${SERVICES_URL}/user`;

export const getUserInfo = (): Promise<any> => axios.get(`${API_URL}/userInfo`).then(response => response.data);
